import { render } from "./AddBtn.vue?vue&type=template&id=198e4a25&scoped=true"
import script from "./AddBtn.vue?vue&type=script&lang=js"
export * from "./AddBtn.vue?vue&type=script&lang=js"

import "./AddBtn.vue?vue&type=style&index=0&id=198e4a25&lang=sass&scoped=true"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198e4a25"]])

export default __exports__